import { PipesModule } from './../core/pipes/pipes.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { PagesRoutingModule } from './pages-routing.module';
import { MovieComponent } from './movie/movie.component';
import { SearchComponent } from './search/search.component';
import { RatingModule } from 'ng-starrating';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ConfirmRegisterComponent } from './confirm-register/confirm-register.component';
import { AccountComponent } from './account/account.component';
import { PagesComponent } from './pages.component';
import { SwiperModule, SWIPER_CONFIG, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { SearchGenreComponent } from './search-genre/search-genre.component';
import { CoreModule } from '../core/core.module';
import { ComponentsModule } from '../components/components.module';
import { SuscriptionComponent } from './suscription/suscription.component';
import { LandingComponent } from './landing/landing.component';
import { ContactComponent } from './contact/contact.component';
import { CatalogueComponent } from './catalogue/catalogue.component';
import { PaymentOverviewComponent } from './payment-overview/payment-overview.component';
import { FilmicArchiveComponent } from './filmic-archive/filmic-archive.component';
import { FaqComponent } from './faq/faq.component';
import { MemberMoviesComponent } from './member-movies/member-movies.component';
import { SmarttvComponent } from './smarttv/smarttv.component';
import { SharedModule } from '../shared/shared.module';
import { UiMovieComponent } from './ui-movie/ui-movie.component';
import { PressMoviesComponent } from './press-movies/press-movies.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ProfileComponent } from './profile/profile.component';
import { ReconnectComponent } from './reconnect/reconnect.component';
import { TagSearchComponent } from './tag-search/tag-search.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { UserCommentsComponent } from './user-comments/user-comments.component';
import { CafComponent } from './caf/caf.component';
import { CafLoginComponent } from './caf-login/caf-login.component';
import { PrivacidadComponent } from './privacidad/privacidad.component';
import { FelixOliverComponent } from './felix-oliver/felix-oliver.component';
import { MembershipInfoComponent } from './membership-info/membership-info.component';
import { AboutFelixOliverOldComponent } from './about-felix-oliver-old/about-felix-oliver-old.component';
import { CatalogueFelixOliverComponent } from './catalogue-felix-oliver/catalogue-felix-oliver.component';
import { AboutFelixOliverComponent } from './about-felix-oliver/about-felix-oliver.component';
import { SubsInfoComponent } from './subs-info/subs-info.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
};

@NgModule({
  declarations: [
    AccountComponent,
    ConfirmRegisterComponent,
    ForgotPasswordComponent,
    HomeComponent,
    LoginComponent,
    MovieComponent,
    RegisterComponent,
    SearchComponent,
    SearchGenreComponent,
    SuscriptionComponent,
    PagesComponent,
    LandingComponent,
    ContactComponent,
    CatalogueComponent,
    PaymentOverviewComponent,
    FilmicArchiveComponent,
    FaqComponent,
    SmarttvComponent,
    MemberMoviesComponent,
    UiMovieComponent,
    PressMoviesComponent,
    MyProfileComponent,
    ProfileComponent,
    ReconnectComponent,
    TagSearchComponent,
    ReviewsComponent,
    UserCommentsComponent,
    CafComponent,
    CafLoginComponent,
    PrivacidadComponent,
    FelixOliverComponent,
    MembershipInfoComponent,
    AboutFelixOliverOldComponent,
    CatalogueFelixOliverComponent,
    AboutFelixOliverComponent,
    SubsInfoComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RatingModule,
    SwiperModule,
    CoreModule,
    ComponentsModule,
    PipesModule,
    SharedModule,
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class PagesModule { }
